<template>
    <div class="mx-1 w-full relative rounded-md bg-[#272727] flex cursor-pointer text-white h-16 mb-2" :class="[isSelected ? 'border-racing-stars-yellow' : '']">
        <span class="flex text-white flex-col justify-center p-1 w-0 fold:w-14">
            <span class="p-1 pl-0 w-14 h-14 hidden fold:inline-flex relative items-center justify-center">
                <img class="w-10" :src="result.runner.silk_image_path"/>
            </span>
        </span>
        <span class="flex text-white flex-col justify-center p-1 w-full">
            <span class="flex flex-col overflow-hidden">
                <span class="text-[12px] sm:text-base flex mr-2 whitespace-nowrap text-racing-stars-yellow font-bold w-14 md:w-full"><p class="pr-[6px]">{{ result.runner.start_number }}</p> {{ truncate(result.runner.horse.name, 16, 16) }}</span>
            </span>
        </span>

        <span class="flex items-end justify-center my-auto pr-2 md:pr-3 md:p-1 text-center">
            <span v-if="result.race_outcome_description.length < 5" :class="getStyles(result).border" class="border-transparent text-white pr-2 rounded-b w-12 md:w-16 text-center align-middle uppercase my-auto">
                <div class="flex flex-col">
                    <span class="text-[10px] md:text-sm font-bold">{{ result.points.toFixed(2) }} </span>
                    <span class="text-[10px] md:text-xs font-bold">Points</span>
                </div>
            </span>

            <!-- <span v-if="(result.race_outcome_description === 'Unseated Rider') || (result.race_outcome_description === 'Pulled Up') || (result.race_outcome_description === 'Ran Out')" :class="getStyles(result).styles" class="dark:bg-gray-600 text-white drop-shadow-lg p-1 rounded w-16 h-10 text-center text-xs font-bold my-auto align-bottom"><p class="align-middle my-auto"> {{result.race_outcome_description}} </p></span> -->
            <span v-if="result.race_outcome_description === 'Unseated Rider'" class="dark:bg-gray-600 text-white drop-shadow-lg rounded w-16 h-10 text-center text-xs font-bold my-auto align-bottom"><p class="align-middle mt-1"> {{result.race_outcome_description}} </p></span>
            <span v-else-if="result.race_outcome_description.length > 5" :class="getStyles(result).styles" class="dark:bg-gray-600 text-white drop-shadow-lg p-1 rounded w-16 h-10 text-center text-xs font-bold my-auto align-bottom"><p class="align-middle text-[10px]"> {{result.race_outcome_description}} </p></span>
            <span v-else :class="getStyles(result).styles" class="p-1 rounded w-8 md:w-fit lg:h-8 text-center text-xs font-bold my-auto align-bottom h-full"><p class="align-middle my-1">{{ result.race_outcome_description }}</p></span>
        </span>
    </div>
</template>

<script>
    import { ref, onMounted } from 'vue'

    export default {
        props: {
            result: {
                type: Object,
                default: {}
            }
        },

        setup(props) {

            const getStyles = (result) => {

                let classes = 'dark:bg-gray-600 text-white drop-shadow-lg'
                let borderClass = 'border-transparent'

                let position = result.position
                let points = result.points !== 0

                if (position === 1 && points) {
                    borderClass = 'border-yellow 800'
                    classes = 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black align-middle'
                }


                if (position === 2 && points) {
                    borderClass = ''
                    classes = 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-gray-800'
                }

                if (position === 3 && points) {
                    borderClass = 'border-yellow-700'
                    classes = 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-gray-800'
                }

                if (position === 4 && points) {
                    borderClass = 'border-gray-800'
                    classes = 'bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 text-white'
                }

                return {
                    styles: classes,
                    border: borderClass,
                }
            }

            const truncate = (str, max, len) => {
                return str.length > max ? str.substring(0, len) + "..." : str;
            }

            return {
                getStyles,
                truncate,
            }

        }
    }
</script>
